export type Partner = {
  id: number;
  businessName: string;
  website: string;
  location: string;
  country: string;
  instagram: string;
  followers: number;
  activityLevel: 'Very Active' | 'Active' | 'Moderately Active' | 'Inactive';
  genericBrandInfo: string;
  type: 'Designers' | 'Multibrand' | 'Second hand';
  numberOfRetailers: number;
  phone?: string;
  email?: string;
  facebook?: string;
  tiktok?: string;
  tiktokFollowers?: number;
  availableBrands?: string[];
  featured?: boolean;
  qualityRating?: number;
  priceRange?: string;
  websiteModernity?: string;
  notes?: string;
  partnersWith?: string[];
  revealed: boolean;
};

export type CreditPackage = {
  credits: number;
  price: number;
  id: string;
  discountPercentage?: number;
  pricePerCredit?: number;
};

export const CREDIT_PACKAGES: CreditPackage[] = [
  { 
    id: 'basic', 
    credits: 25, 
    price: 25,
    discountPercentage: 0,
    pricePerCredit: 1.00
  },
  { 
    id: 'standard', 
    credits: 100, 
    price: 95,
    discountPercentage: 5,
    pricePerCredit: 0.95
  },
  { 
    id: 'premium', 
    credits: 250, 
    price: 200,
    discountPercentage: 20,
    pricePerCredit: 0.80
  },
  { 
    id: 'ultimate', 
    credits: 400, 
    price: 250,
    discountPercentage: 38,
    pricePerCredit: 0.63
  },
]; 